import React from "react";
import styled from "styled-components";
import { Row, Col } from "reactstrap";
import { RebelColors, RebelLabel, RebelInput, RebelSelect } from "../../../styles/rebel-experiences";
import { currencyOptions } from "../../../utils/budget-tool-specific";

const RebelBudgetConfig = ({ config, onChange, tripLength, readOnly }) => {
    return (
        <ConfigContainer>
            <Row>
                <Col lg="6" md="12">
                    <FormGroup>
                        <RebelLabel>Company / Group Name</RebelLabel>
                        <RebelInput
                            type="text"
                            value={config.companyName}
                            onChange={e => onChange("companyName", e.target.value)}
                            placeholder="Enter company name"
                            disabled={readOnly}
                        />
                    </FormGroup>
                </Col>
                <Col lg="3" md="6">
                    <FormGroup>
                        <RebelLabel>Attendees</RebelLabel>
                        <RebelInput
                            type="number"
                            min="1"
                            value={config.attendees}
                            onChange={e => onChange("attendees", parseInt(e.target.value) || 1)}
                            disabled={readOnly}
                        />
                    </FormGroup>
                </Col>
                <Col lg="3" md="6">
                    <FormGroup>
                        <RebelLabel>Currency</RebelLabel>
                        <RebelSelect
                            value={config.currency}
                            onChange={e => onChange("currency", e.target.value)}
                            disabled={readOnly}
                        >
                            {currencyOptions()}
                        </RebelSelect>
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col lg="4" md="4">
                    <FormGroup>
                        <RebelLabel>Start Date</RebelLabel>
                        <RebelDateInput
                            type="date"
                            value={config.startDate}
                            onChange={e => onChange("startDate", e.target.value)}
                            disabled={readOnly}
                        />
                    </FormGroup>
                </Col>
                <Col lg="4" md="4">
                    <FormGroup>
                        <RebelLabel>End Date</RebelLabel>
                        <RebelDateInput
                            type="date"
                            value={config.endDate}
                            min={config.startDate}
                            onChange={e => onChange("endDate", e.target.value)}
                            disabled={readOnly}
                        />
                    </FormGroup>
                </Col>
                <Col lg="4" md="4">
                    <FormGroup>
                        <RebelLabel>Trip Length</RebelLabel>
                        <TripLengthDisplay>
                            {tripLength > 0 ? `${tripLength} night${tripLength !== 1 ? 's' : ''}` : '—'}
                        </TripLengthDisplay>
                    </FormGroup>
                </Col>
            </Row>
        </ConfigContainer>
    );
};

export default RebelBudgetConfig;

const ConfigContainer = styled.div`
    background: linear-gradient(135deg, #000000 0%, #1f2937 50%, #374151 100%);
    border: 1px solid rgba(253, 181, 6, 0.3);
    border-radius: 12px;
    padding: 24px;
    margin-bottom: 0;
    box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.2);
`;

const FormGroup = styled.div`
    margin-bottom: 1rem;
`;

const RebelDateInput = styled(RebelInput)`
    &::-webkit-calendar-picker-indicator {
        filter: invert(1);
        cursor: pointer;
    }
`;

const TripLengthDisplay = styled.div`
    background-color: ${RebelColors.gray700};
    border: 1px solid ${RebelColors.gray600};
    color: ${RebelColors.gold};
    border-radius: 0.5rem;
    padding: 0.5rem 0.75rem;
    font-size: 0.875rem;
    font-weight: 600;
    height: calc(1.5em + 1rem + 2px);
    display: flex;
    align-items: center;
`;
